module.exports = __webpack_public_path__ + "img/asia02.08c9c436.png";